import React from 'react';
import {goTo, FieldGroup} from '../../GlobalTools';


const HeaderView = ({}) => (
<div>
   
</div>
	);

export default HeaderView;



// WEBPACK FOOTER //
// ./src/client/views/header/HeaderView.js